module.exports = __webpack_public_path__ + "img/money-bill-alt.14a44584.svg";